import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import './stepper.scss';
const Stepper = (props) => {
    const { steps } = props;
    return (_jsx("div", { className: "stepper-component", children: steps.map((step, index) => {
            const isSecond = steps[1].active;
            return (_jsxs(_Fragment, { children: [_jsxs(Box, { className: "stepper-component_step", children: [_jsx(Box, { className: `stepper-component_step_number ${!step.active && 'stepper-component_step_number_disabled'}`, children: index + 1 }), _jsx(Box, { className: `stepper-component_step_name ${!step.active && 'stepper-component_step_name_disabled'}`, children: step.name })] }), index + 1 != steps.length &&
                        _jsx(Box, { className: `${isSecond ? 'stepper-component_line-solid' : 'stepper-component_line'}` })] }));
        }) }));
};
export default Stepper;
